<script setup lang="ts">
import type { FooterLinkSocial } from '../..';

defineProps<{ link: FooterLinkSocial }>();
</script>

<template>
  <AppLink
    type="button"
    :to="link.url"
    :opts="{ theme: 'white', link: { external: true, target: '_blank' } }"
  >
    <AppText
      size="custom"
      class="text-base lg:text-lg xl:text-base 2xl:text-lg"
    >
      {{ link.text }}
    </AppText>
    <template #icon>
      <AppIcon :name="link.icon.name" :size="link.icon.size" />
    </template>
  </AppLink>
</template>
